import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DsModalComponent, Sterownik} from 'design-system';
import {Powiadomienie} from '../../../models/powiadomienie.model';
import {NotificationService} from '../../../services/notification.service';
import { DataFilterPowiadomieniaService } from 'src/app/services/data-filter-powiadomienia.service';
import { takeUntil } from 'rxjs/operators';
import { DestroyComponent } from 'src/app/components/destroy/destroy.component';
import { environment } from '../../../../environments/environment';
import { BellNotificationService } from 'src/app/services/bell-notification.service';

@Component({
  selector: 'app-powiadomienia-tabela',
  templateUrl: './powiadomienia-tabela.component.html',
  styleUrls: ['./powiadomienia-tabela.component.scss']
})
export class PowiadomieniaTabelaComponent extends DestroyComponent implements OnInit {

  @Input() tableData: Powiadomienie[];
  @ViewChild('modal', { static: true }) modalContainer: DsModalComponent;
  sterownik: Sterownik;
  id: string;
  dialogOpened = false;
  dialogHeader: string;
  dialogMessage: string;
  action: string = null;
  model: Powiadomienie[] = [];
  loading = false;
  env = environment;
  activeNotificationModal: Powiadomienie;

  constructor(
    private notificationService: NotificationService,
    private dataFilterService: DataFilterPowiadomieniaService,
    private bellNotificationService: BellNotificationService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.sterownik = {
      key: '',
      name: 'newsLetterNotifs',
      stateStorage: 'session',
      columns: [
        {header: 'Data zdarzenia', field: 'registrationDate', dataType: 'string', sortable: true},
        {header: 'Nr KRS', field: 'krs', dataType: 'string', sortable: true},
        {header: 'Nazwa', field: 'nazwaPodmiotu', dataType: 'string', sortable: true},
        {header: 'Typ zdarzenia', field: 'type', dataType: 'string', sortable: true},
        {header: 'Akcje', field: 'actions', dataType: 'string', width: '90px'}
      ],
      paginator: {
        rowsPerPageOptions: [10, 20, 50],
        rows: 10,
      },
    };

    this.notificationService.loading$
      .pipe(takeUntil(this.destroy$))
      .subscribe(value => {
        this.loading = value;
      });
  }

  showAllNotificationsPRS(): void {
    location.href = this.env.portalUrl + '/powiadomienia';
  }

  viewNotification(element: Powiadomienie): void {
    this.activeNotificationModal = element;
    this.id = element.id;

    this.notificationService.sendNotificationSeen(element.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        element.wasSeen = true;
        element.dsRowClassNames = '';
        this.bellNotificationService.setReloadNotifiactions();
      });

    this.modalContainer.enableModal();
  }

  deleteNotification(element: Powiadomienie, action: string): string {
    if(element.deleted !== true) {
      this.dialogOpened = true;
      this.id = element.id;
      this.action = action;
      this.dialogHeader = 'usuniecieNaglowek';
      this.dialogMessage = 'usunieciePowiadomienieWiadomosc';
      return this.id;
    }
  }

  confirmClosed(confirmed: boolean): void {
    if (confirmed) {
      this.notificationService.deleteNotification(this.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => {
          this.dataFilterService.dataFilter.next(this.dataFilterService.dataFilter.getValue());
          this.bellNotificationService.setReloadNotifiactions();
        });
    }
    this.id = null;
    this.action = null;
  }

  hideModal(): void {
    this.modalContainer.disableModal();
  }
}
